import FondationsServiceModel from '@/models/FondationsServiceModel';

export default class UserConfirmEmailTokenModel extends FondationsServiceModel {
	static get path(): string {
		return '/users/confirm_email/token?t={?token}';
	}
}
